import { Illustration, Text } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";

export function NewsFeedErrorPageState() {
  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      spacing={8}
      flexGrow={1}
      textAlign="center"
      sx={{ textWrap: "balance" }}
    >
      <Illustration type="error" />
      <Text variant="body1">Error loading your news feed...</Text>
    </Stack>
  );
}
